var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuddenAceleration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.50013 10.7333C0.50013 16.385 5.08175 20.9667 10.7335 20.9667C16.3852 20.9667 20.9668 16.385 20.9668 10.7333C20.9668 5.08162 16.3852 0.5 10.7335 0.5C5.08175 0.5 0.50013 5.08162 0.50013 10.7333Z",
    fill: "#CB4AE2",
    stroke: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7686 10.3113L10.9984 11.6949",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9223 11.695C11.9223 12.2049 11.5091 12.6181 10.9992 12.6181C10.4894 12.6181 10.0762 12.2049 10.0762 11.695C10.0762 11.1852 10.4894 10.772 10.9992 10.772C11.5091 10.772 11.9223 11.1852 11.9223 11.695Z",
    fill: "white",
    stroke: "#2A2D34",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.2334V16.4026V15.5719",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3L12 3",
    stroke: "#2A2D34",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.2334L16.4642 6.59583",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5H7",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H6",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14H6",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55166 8C7.5516 6.6263 9.17218 5.7334 11.0013 5.7334C14.0389 5.7334 16.5013 8.19583 16.5013 11.2334C16.5013 14.271 14.0389 16.7334 11.0013 16.7334C9.42117 16.7334 7.99666 16.067 6.99346 15H5.70326C6.88157 16.6544 8.81544 17.7334 11.0013 17.7334C14.5912 17.7334 17.5013 14.8232 17.5013 11.2334C17.5013 7.64355 14.5912 4.7334 11.0013 4.7334C8.58855 4.7334 6.48283 6.04799 5.36133 8H6.55166Z",
    fill: "#2A2D34"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6854 11.6948H15.3008",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.2334L11 4.7334L11 6.2334",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuddenAceleration);
export default __webpack_public_path__ + "static/media/Icon_sudden_aceleration.6aae0c865797bc8cadbc24271c4a7727.svg";
export { ForwardRef as ReactComponent };